<template>
  <div class="page dashboard-page">
    <el-row :gutter="15" class="wrapper">
      <el-col :span="8">
        <el-row :gutter="15" class="special-card-wrapper">
          <el-col :lg="24">
            <div class="card section">
              <p class="page-title">小程序总数</p>
              <div class="content">
                <div class="item">
                  <p class="name">已授权小程序总数</p>
                  <h1><strong>{{wtpp_applications_count}}</strong></h1>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="8">
        <el-row :gutter="15" class="special-card-wrapper">
          <el-col :lg="24">
            <div class="card section">
              <p class="page-title">应用总数</p>
              <div class="content">
                <div class="item">
                  <p class="name">应用总数</p>
                  <h1><strong>{{applications_count}}</strong></h1>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="8">
        <el-row :gutter="15" class="special-card-wrapper">
          <el-col :lg="24">
            <div class="card section">
              <p class="page-title">用户总量</p>
              <div class="content">
                <div class="item">
                  <p class="name">用户总量</p>
                  <h1><strong>{{users_count}}</strong></h1>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <el-row class="wrapper">
      <div class="card section">
        <div class="content">
          <div class="visit-table">
            <p class="name">最近一周新增应用/用户情况</p>
            <bean-table :height="null" :value="table.data" :columns="columns" />
          </div>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
  import { Vue, Component } from 'vue-property-decorator';

  @Component
  export default class SuperHome extends Vue {
    wtpp_applications_count = 0
    applications_count = 0
    users_count = 0
    table = {
      data: []
    }

    get columns() {
      return [
        {
          prop: 'ref_date',
          label: '日期'
        },
        {
          prop: 'new_applications_count',
          label: '应用数'
        },
        {
          prop: 'new_users_count',
          label: '用户数'
        }
      ];
    }

    async mounted() {
      const data = await this.$request.get('/dashboard');
      this.table.data = data.recent_one_week;
      this.wtpp_applications_count = data.wtpp_applications_count;
      this.applications_count = data.applications_count;
      this.users_count = data.users_count;
    }
  }
</script>

<style lang="scss" scoped>
  .page-title {
    padding: 8px 20px;
    border-bottom: 1px solid $border-light;
    margin: 0;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    font-size: 14px;
    color: #fff;
    background: $primary;
  }

  .section {
    @include shadow;
    margin-top: 20px;
  }

  .content {
    background: #fff;
  }

  .qr-code {
    width: 100px;
  }

  .el-button {
    width: 100%;
  }

  .customer-connect {
    font-size: 18px;
    color: #399e62;
    cursor: pointer;
    text-decoration-line: underline;
  }

  .special-card-wrapper {
    display: flex;
    margin-bottom: 15px;

    .card {
      flex: 1;
    }
  }

  .bind-button {
    margin-top: 45px;
  }

  .go-register {
    margin-top: 35px;
  }

  .tip {
    margin-top: 15px;
    margin-bottom: 20px;
    font-size: 12px;
    color: #86888b;
    padding: 0 14px;
    text-align: left;
  }

  .visit-table {
    flex: 1;
    margin: 0.5em 0;
    padding: 1em;
    text-align: center;

    .name {
      margin-top: 15px;
      margin-bottom: 20px;
      font-size: 14px;
      font-weight: 500;
      color: #86888b;
    }
  }

  .card {
    .page-title {
      text-align: center;
      font-weight: bold;
    }

    .content {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .item {
      flex: 1;
      height: 126.7px;
      margin: 0.5em 0;
      text-align: center;

      .pending-bind-tips {
        line-height: 126.7px;
      }

      [class^="el-icon-"] {
        font-size: 30px;
        margin-top: 10px;
      }

      .name {
        margin-top: 15px;
        margin-bottom: 20px;
        font-size: 14px;
        color: #86888b;
      }

      .value {
        line-height: 78px;
        font-size: 24px;
      }
    }
  }
</style>
